import cn from 'classnames';
import React, {FC} from 'react';

import s from './records-info.module.less';

interface IRecordsInfoProps {
    current: number | undefined;
    pageSize: number | undefined;
    documentsTotalCount: number | undefined;
    classNames?: string | string[];
}

export const RecordsInfo: FC<IRecordsInfoProps> = ({
    current,
    pageSize,
    documentsTotalCount,
    classNames,
}: IRecordsInfoProps) => {
    const startRecord = current && pageSize ? (current - 1) * pageSize + 1 : 0;
    const endRecord = current && pageSize && documentsTotalCount ? Math.min(current * pageSize, documentsTotalCount) : 0;

    const recordsInfo = documentsTotalCount
        ? `${startRecord} - ${endRecord} из ${documentsTotalCount} записей`
        : 'Нет доступных записей';

    return (
        <div className={cn(s['records-info'], classNames)}>
            <h4>{recordsInfo}</h4>
        </div>
    );
}
